window.adobeDataLayerPushWebEvents = function(event, webPayload) {
    window.adobeDataLayer = window.adobeDataLayer || [];
    window.adobeDataLayer.push({
        event,
        web : webPayload
    });
}

window.adobeInternalLinkClickTrack = function(name, location, href, pageName = 'clo:home') {
    adobeDataLayerPushWebEvents("internalLinkClick", {
        internalLink : {
            linkName : name,
            linkHref: href,
            linkLocation: location
        },
        pageDetails: {
            name: pageName
        }
    })
}

window.adobeAccordionClickTrack = function(name, category) {
    adobeDataLayerPushWebEvents("accordionClick", {
        accordion : {
            accordionName : name,
            accordionCategory: category
        }
    })
}

window.adobeCtaLinkClickTrack = function(name, location, href, pageName = 'clo:home') {
    // console.log({name,href,location})
    adobeDataLayerPushWebEvents("CTAClick", {
        CTAClick: {
            linkName: name,
            linkHref: href,
            linkLocation: location
        },
        pageDetails: {
            name: pageName
        }
    })
}

window.adobeFormStartTrack = function(formName) {
    adobeDataLayerPushWebEvents("formStart", {
        form: {
            formName
        }
    })
}

window.adobeFormCompleteTrack = function(formName) {
    adobeDataLayerPushWebEvents("formComplete", {
        form: {
            formName
        }
    })
}
window.adobePageViewsTrack = function(pageName) {
    console.log("clo:"+pageName);
    let payload = {
        pageDetails: {
            name: "clo:"+pageName,
            // previousPageName: "<previous page name>",
            title: document.title,
            url: document.URL,
            // subSection1: "",
            category: "page",
            // loadTime: "<load time in seconds with 3 decimal places, (ex 6.123)>"
        },
        collector: {
            // id: "<collector ID>",
            // tier: "<collector tier>",  //blue/gold/onyx
            // login_status: "<login_status>", //logged_in/not_logged_in/recognized
            // cash_miles: "<cash_miles>",
            // dream_miles: "dream_miles",
            // cash_miles_pref: "cash_miles_pref" //cash miles preference % (0 to 100)
        },
        siteDetails: {
            domain: window.location.host,
            section: "clo:"+pageName,
            subsection: "clo:"+pageName,
            language: document.documentElement.lang, //en/fr
            screen_height: screen.height,
            screen_width: screen.width
        }
    };
    adobeDataLayerPushWebEvents("pageViews", payload);
}
